import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-pager-setup',
    templateUrl: './pager-setup.component.html',
    styleUrls: ['./pager-setup.component.scss'],
    standalone: false
})
export class PagerSetupComponent implements OnChanges {
  @Input() totalPages = 0;
  @Input() currentPage = 1;
  @Output() pageChange = new EventEmitter<number>();

  steps: number[] = [];
  activePage = 1;

  ngOnChanges(_: SimpleChanges): void {
    this.syncSteps();
    this.syncActivePage();
  }

  onStepClick(step: number): void {
    if (step === this.activePage) {
      return;
    }

    this.pageChange.emit(step);
  }

  trackByStep(_: number, step: number): number {
    return step;
  }

  private syncSteps(): void {
    const safeTotal = Math.max(0, Math.floor(this.totalPages));
    this.steps = Array.from({ length: safeTotal }, (_, index) => index + 1);
  }

  private syncActivePage(): void {
    if (!this.steps.length) {
      this.activePage = 0;
      return;
    }

    const isCurrentValid = this.steps.includes(this.currentPage);
    this.activePage = isCurrentValid ? this.currentPage : this.steps[0];

    if (!isCurrentValid) {
      this.pageChange.emit(this.activePage);
    }
  }
}


